import { createTheme } from '@mui/material/styles';
import { grey, purple } from '@mui/material/colors';
import { lighten } from '@mui/system';

const customIconColor = '#FC96A2';
const primaryPink = '#FC96A2';
const secondaryPink = '#E86E7B';
const lightBlue = '#8D8DE8';
const primaryBlue = '#000453';

const getDesignTokens = (mode) => ({
  palette: {
    background: {
      default: '#f2eff7',
    },
    mode,
    primary: {
      main: secondaryPink,
      ...(mode === 'dark' && {
        main: purple[300],
      }),
    },
    ...(mode === 'dark' && {
      background: {
        default: grey[900],
        paper: grey[800],
      },
    }),
    text: {
      ...(mode === 'light'
        ? {
          primary: grey[900],
          secondary: grey[800],
        }
        : {
          primary: '#fff',
          secondary: grey[500],
        }),
    },
    customColors: {
      iconColor : customIconColor,      
      lightPink: primaryPink,
      mediumPink: secondaryPink,
      lightBlue,
      darkBlue: primaryBlue,
    },
  },
  typography: {
    fontFamily: 'Inter, sans-serif',
    body1: {
      fontFamily: 'Inter, sans-serif',
    },
    h1: {
      fontFamily: 'Inter, sans-serif',
      color: primaryBlue,
      fontWeight: 500,
    },
    h2: {
      fontFamily: 'Inter, sans-serif',
      color: primaryBlue,
      fontWeight: 500,
    },
    h3: {
      fontFamily: 'Inter, sans-serif',
      color: primaryBlue,
      fontWeight: 500,
    },
    h4: {
      fontFamily: 'Inter, sans-serif',
      color: primaryBlue,
      fontWeight: 500,
    },
    h5: {
      fontFamily: 'Inter, sans-serif',
      color: primaryBlue,
      fontWeight: 500,
    },
    h6: {
      fontFamily: 'Inter, sans-serif',
      color: primaryBlue,
      fontWeight: 500,
    },
    documentTitle: {
      fontSize: '35pt', // Adjusted size
      fontWeight: 'bold',
      fontFamily: 'Inter, sans-serif',
      color: primaryBlue,
    },
    sectionTitle: {
      fontSize: '20pt',
      fontWeight: 'bold',
      fontFamily: 'Inter, sans-serif',
      color: primaryBlue,
    },
    sectionSubtitle: {
      fontSize: '16pt',
      fontWeight: 'bold',
      fontFamily: 'Inter, sans-serif',
      color: primaryBlue,
    },
  },
  components: {
    MuiInputBase: {
      styleOverrides: {
        root: { // this targets the root of the component
          backgroundColor: '#ffffff', // set the background color to white
        },
        input: {
          color: grey[500],
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          // Any global styles for all buttons can go here
        },
        containedPrimary: {
          backgroundColor: primaryBlue,
          color: '#fff', // Set the button text color to white for primary color
          '&:hover': {
            backgroundColor: lighten(primaryBlue, 0.2),  // Lightens the primary button on hover
          },
        },
        containedSecondary: {
          backgroundColor: secondaryPink,  // Assuming you want mediumPink for secondary buttons
          color: '#fff', // Set the button text color to white for secondary color
          '&:hover': {
            backgroundColor: lighten(secondaryPink, 0.2),  // Lightens the secondary button on hover
          },
        },
      },
    },
    
  },
});

export const cetraLightModeTheme = createTheme(getDesignTokens('light'));
